<template>
	<div>
		<div v-if="hasValidationErrors" class="alert alert-bad">
			<ul>
				<li v-for="error in errors" :key="`${ field }-${ error }`"><span class="fa fa-flag"></span>{{ error }}</li>
			</ul>
		</div>
		<div class="conjoin-input-containers">
			<div class="input-container">
				<div class="input-title">{{ field.name }}</div>
			</div>
			<div class="input-container">
				<div v-if="!!max" class="input-box"><textarea v-model="inputVal" :placeholder="field.placeholder" @input="onChange" v-bind="$attrs"></textarea></div>
				<div v-else class="input-box"><textarea-autosize v-model="inputVal" :placeholder="field.placeholder"></textarea-autosize></div>
			</div>
			<div v-if="!!max" class="input-container">
				<div class="input-static-text"><span :class="charactersUsedClass">{{ charactersUsed }}</span> / {{ max }} Char<span class="hide-on-mobile">acter</span>s Used</div>
			</div>
		</div>
	</div>
</template>

<script>

import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	computed: {

		max() {
			return parseInt(this.field.config.max_length, 10);
		},

		charactersUsedClass() {
			return this.charactersUsed < this.max ? 'good-text' : 'bad-text';
		},

		charactersUsed() {
			if (!this.inputVal) return 0;

			return this.inputVal.toString().length;
		},
	},

	// watch: {
	//
	// 	value: function() {
	// 		this.inputVal = this.value;
	// 		this.onChange();
	// 	},
	//
	// },

	mounted() {
		this.onChange();
	},

	methods: {

		onChange() {
			if (this.charactersUsed > this.max) {
				this.inputVal = this.inputVal.substring(0, this.max);
			}

			// this.$emit('input', this.inputVal);
		},

	},

};

</script>
